const MAP = {
  MET: { label: "Met", cls: "bg-success-bg text-success border border-green-200" },
  PARTIAL: { label: "Partial", cls: "bg-warning-bg text-warning border border-amber-200" },
  NOT_MET: { label: "Not Met", cls: "bg-danger-bg text-danger border border-red-200" },
  NEEDS_REVIEW: { label: "Needs Review", cls: "bg-sky-50 text-brand-accent border border-sky-200" },
};

export default function StatusBadge({ status }) {
  const s = MAP[status] || MAP.NOT_MET;
  return (
    <span className={`inline-block px-2 py-0.5 rounded text-xs font-semibold ${s.cls}`} data-testid={`status-${status}`}>
      {s.label}
    </span>
  );
}
